import * as GoogleTag from '.';

export interface AdInfo {
  dimensions: GoogleTag.Dimension[];
  elementId: string;
  targeting: Record<string, string>;
}

let currentTargeting: GoogleTag.Targeting | undefined;
const slotQueue: AdInfo[] = [];

function processSlotQueue(): void {
  console.log('[ADS] processSlots', JSON.stringify(slotQueue), currentTargeting?.adUnit);
  while (slotQueue.length > 0) {
    const adSlotInfo = slotQueue.shift()!;
    // eventually we will ad lazyload logic here
    GoogleTag.defineSlot({
      ...adSlotInfo,
      adUnitPath: currentTargeting?.adUnit || '',
    });
    GoogleTag.display(adSlotInfo.elementId);
  }
}

export function initializeGoogleAds(): void {
  console.log('[ADS] initializeGoogleAds');
  GoogleTag.restrictDataProcessing();
}

export function setAdTargeting(targeting: GoogleTag.Targeting): void {
  console.log('[ADS] set page targeting', JSON.stringify(targeting));
  GoogleTag.clearTargeting();
  GoogleTag.setPageTargeting(targeting);
  GoogleTag.enableService();
  currentTargeting = targeting;
  processSlotQueue();
}

export function createAd(adInfo: AdInfo): void {
  console.log('[ADS] createAd', adInfo, currentTargeting);
  if (currentTargeting) {
    // eventually we will ad lazyload logic here
    GoogleTag.defineSlot({
      ...adInfo,
      adUnitPath: currentTargeting?.adUnit || '',
    });
    GoogleTag.display(adInfo.elementId);
  } else {
    slotQueue.push(adInfo);
  }
}

export function clearAdTargeting(): void {
  console.log('[ADS] clear targeting', currentTargeting?.adUnit);
  GoogleTag.clearTargeting();
  currentTargeting = undefined;
  slotQueue.length = 0;
}

export function destroyAd(elementId: string): void {
  console.log('[ADS] destroyAd', elementId);
  GoogleTag.destroySlot(elementId);
}
